var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 189.512,
    height: 161.338,
    viewBox: "0 0 189.512 161.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Data_Security",
    "data-name": "Data Security",
    transform: "translate(-1 -3.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19723",
    "data-name": "Path 19723",
    d: "M38.46,138.731a4.779,4.779,0,0,0,.948.063h5.433V109.547A15.758,15.758,0,0,1,59.559,93.817a36.329,36.329,0,0,1,72.393,0,15.758,15.758,0,0,1,14.719,15.729v29.248H152.1a4.777,4.777,0,0,0,.948-.063,44.182,44.182,0,0,0-3.664-87.744A54,54,0,0,0,95.756,3.23,54.059,54.059,0,0,0,42.124,50.987a44.182,44.182,0,0,0-3.664,87.744Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19724",
    "data-name": "Path 19724",
    d: "M50.88,13.81A26.906,26.906,0,0,0,24.032,40.658v6.317H15.757A6.336,6.336,0,0,0,9.44,53.292V102a6.3,6.3,0,0,0,6.317,6.317H86A6.3,6.3,0,0,0,92.32,102v-48.7A6.336,6.336,0,0,0,86,46.975H77.728V40.658A26.906,26.906,0,0,0,50.88,13.81ZM65.093,46.975H36.667V40.658a14.213,14.213,0,1,1,28.427,0Z",
    transform: "translate(44.876 56.255)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSecurity);
export default __webpack_public_path__ + "static/media/Data Security.66e120f01d152385f4695982620aec10.svg";
export { ForwardRef as ReactComponent };